const routes = [
    {
        path: "/bisep/application/form",
        component: () => import("../pages/ApplicationForm")
    },
    {
        path: "/bisep/application/login",
        component: () => import("../pages/Login")
    },
    {
        path: "/bisep/application/register",
        component: () => import("../pages/Register")
    },
    {
        path: "/bisep/application/forgot/password",
        component: () => import("../pages/ForgotPassword")
    },
    /// Admin
    {
        path: "/bisep/applications",
        component: () => import("../pages/admin/Index"),
        meta: {
            isAuthenticated: true,
            //permission: 'cartoonanimationapplication_index'
        }
    },
    {
        path: "/bisep/application/exam-types",
        component: () => import("../pages/admin/examTypes/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: "cartoonanimationapplicationexamtype_index",
        }
    },
    {
        path: "/bisep/application/quotas",
        component: () => import("../pages/admin/quotas/Index"),
        meta: {
            isAuthenticated: true,
            permission: "cartoonanimationapplicationquota_index"
        }
    }

];

export default routes;
